// extracted by mini-css-extract-plugin
var _1 = "CustomStepsStyle-module__steps___e7qd1";
export { _1 as "steps" }
